module.exports = __webpack_public_path__ + "img/mono-rounded.be43f672.svg";